export default {
	methods: {
		$could(permission, resource = null) {
			if (!this.$store.state.authStore.authed) {
				return false;
			}

			if (!resource) {
				let path = permission.split(".");
				permission = path.pop();

				let node = this.$store.state.authStore.authed.permissions;

				for (let i in path) {
					node = node[path[i]];
				}

				return _.has(node, permission);
			}

			return _.has(resource.actions, permission);
		},
		$can(permission, resource = null) {
			if (!this.$store.state.authStore?.authed) {
				return false;
			}

			if (!this.$could(permission, resource)) {
				return false;
			}

			if (!resource) {
				let path = permission.split(".");
				permission = path.pop();

				let node = this.$store.state.authStore.authed.permissions;

				for (let i in path) {
					node = node[path[i]];
				}

				return _.get(node, permission);
			}

			return resource.actions[permission] || false;
		},
		$couldGuest(permission, resource) {
			return _.has(resource.actions, permission);
		},
		$canGuest(permission, resource) {
			if (!this.$couldGuest(permission, resource)) {
				return false;
			}
			return resource.actions[permission];
		},
	},
};
